import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "React",
    "TypeScript",
    "JavaScript",
    "HTML5",
    "CSS3",
    "SASS",
    "Flask",
    "Python",
    "SQL",
    "PostgreSQL",
    "Postman"
];

const labelsSecond = [
    "Git",
    "GitHub Actions",
    "Docker",
    "AWS",
    "Azure",
    "Linux",
    "Snowflake",
    "Pandas",
    "Selenium",
];

const labelsThird = [
    "OpenAI",
    "Groq",
    "LangChain",
    "Qdrant",
    "Hugging Face",
    "LlamaIndex",
    "Streamlit",
];

function Expertise() {
    return (
    <div className="container about-section" id="expertise" style={{ boxShadow: 'inset 0px 0px 10px rgba(0, 0, 0, 0.05)' }}>
        <div className="page-contents">
        <div className="skills-container">
            <h1>About</h1>
            <div className="skills-grid">
                <div className="skill">
                    {/* <FontAwesomeIcon icon={faReact} size="3x"/> */}
                    <h3>The Team</h3>
                    <p>Technically speaking, RocLily is a solo developer who sometimes collaborates with other developers, with a wide range of skills and expertise. Ranging from frontend to backend development, RocLily is capable of handling various aspects of a project.</p>
                    {/* <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div> */}
                </div>

                <div className="skill">
                    {/* <FontAwesomeIcon icon={faDocker} size="3x"/> */}
                    <h3>Capabilities</h3>
                    <p>RocLily has a strong focus on mobile development, automation, and cloud technologies, ensuring efficient and scalable solutions. RocLilys preffered programming language is C# but in reality will adapt to the best tool for the job. Javascript and Python are often the most utlized languages.</p>
                    {/* <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div> */}
                </div>

                <div className="skill">
                    {/* <FontAwesomeIcon icon={faPython} size="3x"/> */}
                    <h3>Drive & Goals</h3>
                    <p>RocLily has always had a strong understanding of computers and technology, constantly striving to improve and innovate. The goal is to leverage this expertise to create impactful solutions and drive technological advancements.</p>
                    {/* <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div> */}
                </div>
            </div>
        </div>
        </div>
    </div>
    );
}

export default Expertise;